import { FC, ReactNode } from "react";
import { getStaticUrl } from "../../utils";
import { Button } from '../ui-kit/RoundButton';
import { BuyTicketWrapper } from "../tickets/BuyTicketWrapper";

interface TeamInfoProps {
    name: string;
    logo: string;
}
const TeamInfo: FC<TeamInfoProps> = ({
    name,
    logo,
}) => {
    let titleClassNames = "text-center";
    if (name.length > 20) {
        titleClassNames += ' ';
    } else {
        titleClassNames += ' text-xl';
    }
    return (
        <div className="flex flex-col items-center w-28 ">
            <img src={getStaticUrl(logo)} className="w-20 h-20 object-contain" />
            <div className={titleClassNames}>{name}</div>
        </div>
    );
}


interface CalendarEventProps {
    name: string;
    url: string;
    date: string;
    team1: {
        name: string;
        logo: string;
    };
    team2: {
        name: string;
        logo: string;
    };
    score?: ReactNode;
    matchUrl?: string;
    ticketUrl?: string;
    classNames?: string;
}

export const CalendarEvent: FC<CalendarEventProps> = ({
    name,
    url,
    date,
    team1,
    team2,
    score,
    matchUrl,
    ticketUrl,
    classNames = 'text-white bg-sky-950/95 ',
}) => {
    const containerClassNames = "box-border hover:shadow-md transition-all rounded-xl min-w-full min-h-32 h-64 flex flex-col items-center gap-8 px-4 py-3 " + classNames;
    return (
        <div className="min-w-64 px-2 py-3 select-none box-border" style={{ fontFamily: 'Futura, sans-serif' }}>
            <div className={containerClassNames}>
                <div className="text-center">
                    <a href={url} className="text-inherit hover:no-underline text-center text-xl mx-auto">{name}</a>
                    <div className="text-center text-2xl font-medium">
                        {date}
                    </div>
                </div>
                <div className="flex flex-row justify-between w-full font-medium">
                    <TeamInfo name={team1.name} logo={team1.logo} />
                    <div className="h-20 flex flex-col items-center justify-center">
                        {score && <a href={matchUrl} className="text-inherit hover:no-underline">
                            {score}
                        </a>}
                        {!score && !ticketUrl && <div className="text-5xl font-medium pb-3">
                            - : -
                        </div>}
                        {ticketUrl && <><BuyTicketWrapper url={ticketUrl}><Button title="Билет" href={ticketUrl} size="xs" className="italic" /></BuyTicketWrapper><div id="scrollTo" /></>}
                </div>
                <TeamInfo name={team2.name} logo={team2.logo} />
            </div>
        </div>
        </div >
    );
}